module.exports = __webpack_public_path__ + "static/media/hbb_grid_2.80f4f5dc.png";